<app-breadcrumbs></app-breadcrumbs>
<div class="instructions">
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <strong>How to Use</strong>
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <h5><strong>Steps</strong></h5>
      <h6>Before Install</h6>
      <p><em>Any time before install, but ideally the same day</em></p>
      <ol>
        <li><strong>Before</strong> beginning the Kevlar2 refresh at a store, type in the store number in the box below.</li>
        <li>Hit Create New Snapshot/Create One. This will take a snapshot of the store’s clients, APs, and similar things.</li>
        <!-- <li>If you get the message “Success," refresh the page and you’ll see a snapshot show up.</li> -->
      </ol>
      <h6>After Install</h6>
      <p><em>Twenty (20) minutes after the physical install is complete</em></p>
      <ol>
        <li><strong>After</strong> the install process, create another snapshot by hitting <strong>Create New Snapshot</strong>.</li>
        <li>Now you will select two snapshots to compare and run checks on. Find the snapshot you took before the install (check the timestamp) and click <strong>Add</strong> on the right.</li>
        <li>Find the snapshot you took after the install and click <strong>Add</strong>. <strong>Make sure</strong> you add them in the correct order.</li>
        <li>In the boxes below, you should see the BEFORE Snapshot on the left and the AFTER Snapshot on the right.</li>
        <li>Click Run.</li>
        <li>If a test fails, it will signify that. Click on the specific test for more details.</li>
      </ol>
      <h5><strong>Tips</strong></h5>
      <ul>
        <li>There is a possibility that the response from the server will time out. If this happens, an error message will pop up (saying "Notice"). You will see it show up in the list as "In Progress."</li>
        <li>For an accurate validation, It is <strong>very</strong> important that the second snapshot is taken at least 20 minutes after the installation is completed. The second test <strong>Clients on Ports 1-18, 22</strong> will automatically fail, because Meraki hasn’t had enough time to gather data.</li>
        <li>Make sure the BEFORE Snapshot and AFTER Snapshot are added to the boxes in the correct order.</li>
      </ul>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<div class="store-number-toolbar">
  <div [cfaLoading]="isLoading">
    <button mat-raised-button (click)="getAvailableKevlar2Indexes()" color="primary" id="store-number-search-button">
      <mat-icon>search</mat-icon>
    </button>
    <mat-form-field id="store-number-search-field" appearance="outline">
      <mat-label>Store Number</mat-label>
      <input matInput  type="string" maxlength="5" minLength="5" (keydown.enter)="isStoreNumberInvalid() ? $event.preventDefault() : getAvailableKevlar2Indexes()" autofocus
        [(ngModel)]="storeNumberInput" />
    </mat-form-field>
  </div>
</div>

<div [cfaLoading]="isLoading">
  @if (availableIndexesLoaded && availableIndexes.length < 1) {
    <div id="noIndexes" >
      <strong>Looks like this store doesn't have a snapshot. </strong>
      <button mat-flat-button color="primary" id="createIndex" (click)="createKevlar2Index()">Create One</button>
    </div>
  }

  <div class="heading" [ngStyle]="{'display': displayAvailableIndexesHeader()}">
    <h4 class="subheading">Available Snapshots</h4>
    <button mat-stroked-button color="primary" id="createIndexButton" (click)="createKevlar2Index()">Create New Snapshot <mat-icon>settings_input_component</mat-icon> </button>
  </div>

  <div id="available-indexes-table-wrapper" [ngStyle]="{'display': displayAvailableIndexesTable()}">
    <mat-form-field>
      <input matInput (keyup)="applyAvailableIndexesFilter($event.target.value)" placeholder="Filter">
    </mat-form-field>

    <table id="available-indexes-table" #availableIndexesTable mat-table [dataSource]="availableIndexesDataSource">
      <ng-container matColumnDef="store">
        <th mat-header-cell *matHeaderCellDef> Store Number </th>
        <!-- <td class="store-number-cell" [routerLink]="['/health/device']" [queryParams]="{storeNumber:location.number}" mat-cell -->
        <td mat-cell *matCellDef="let index"> {{index.store}} </td>
      </ng-container>
      <ng-container matColumnDef="timestamp">
        <th mat-header-cell *matHeaderCellDef> Timestamp </th>
        <td mat-cell *matCellDef="let index"> {{toInt(index.timestamp) * 1000 | date:'medium' }} </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let index">
          @if (index.status == 'in_progress') {
            <span>
              <mat-spinner matTooltip="Snapshot creation in progress"
              [matTooltipClass]="'my-tooltip'" [diameter]="24"></mat-spinner>
            </span>
          }
          @if (index.status == 'success') {
            <span>
              <mat-icon matTooltip="Snapshot creation succeeded"
                [matTooltipClass]="'my-tooltip'" class="greenText">check_circle_outline
              </mat-icon>
            </span>
          }
          @if (index.status == 'failure') {
            <span>
              <mat-icon matTooltip="Snapshot creation failed"
                [matTooltipClass]="'my-tooltip'" class="redText">highlight_off
              </mat-icon>
            </span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> Action </th>
        <td mat-cell  *matCellDef="let index">
          @if (index.status == 'success') {
            <button mat-flat-button color="primary" (click)="selectIndex({'store': index.store, 'timestamp': index.timestamp})"> Add </button>
          }
          <!-- <button *ngIf="index.status != 'success'" mat-flat-button color="primary" (click)="selectIndex({'store': index.store, 'timestamp': index.timestamp})"> Add </button>  -->
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsAvailableIndexes;"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsAvailableIndexes;"></tr>
    </table>
    <mat-paginator #availableIndexesPaginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>


    <div class="selected-indexes-cards-container" class="cards">
      @if (selectedIndexes.length > 0) {
        <mat-card class="card">
          <mat-card-content class="card-content">
            <h3 class="card-header">{{ selectedIndexes[0].timestamp * 1000 | date:'medium' }}</h3>
            Store {{ selectedIndexes[0].store }}
          </mat-card-content>
        </mat-card>
      }
      @if (selectedIndexes.length > 1) {
        <mat-card class="card">
          <mat-card-content class="card-content">
            <h3 class="card-header">{{ selectedIndexes[1].timestamp * 1000 | date:'medium' }}</h3>
            Store {{ selectedIndexes[1].store }}
          </mat-card-content>
        </mat-card>
      }

      @if (selectedIndexes.length < 1) {
        <mat-card class="card card-empty">
          <mat-card-content class="card-content card-content-empty">
            <h3 class="card-header card-header-empty">{{ "Add a BEFORE Snapshot" }}</h3>
            {{ "Before" }}
          </mat-card-content>
        </mat-card>
      }
      @if (selectedIndexes.length < 2) {
        <mat-card class="card card-empty">
          <mat-card-content class="card-content card-content-empty">
            <h3 class="card-header card-header-empty">{{ "Add an AFTER Snapshot" }}</h3>
            {{ "After" }}
          </mat-card-content>
        </mat-card>
      }
      <div class="selected-indexes-buttons-container">
        <button mat-stroked-button color="primary" id="deselectButton" (click)="deselect()" class="icon-only-button"><mat-icon>delete_sweep</mat-icon> </button>
        <button [cfaLoading]="compareIsRunning" mat-stroked-button color="primary" id="submitCompareButton" (click)="submitCompare(selectedIndexes)" [disabled]="selectedIndexes.length < 2">Run<mat-icon>play_circle_outline</mat-icon> </button>
      </div>
    </div>



  </div>

  @if (compareResultsReceived) {
    <div class="compareResults">
      @if (allTestsGood) {
        <h2 style="margin-top: 10px; margin-bottom: 10px; color: var(--badge-online);">All Tests Passed</h2>
      }
      @if (!allTestsGood) {
        <h2 style="margin-top: 10px; margin-bottom: 10px; color: var(--badge-offline);">Some Tests Failed</h2>
      }
      <mat-accordion>
        <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title>
              @if (checkNumApsGood) {
                <mat-icon class="resultsIconSuccess">check_circle</mat-icon>
              }
              @if (!checkNumApsGood) {
                <mat-icon class="resultsIconFailure">remove_circle</mat-icon>
              }
              Number of APs
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <h6><strong>Before</strong></h6>
          <p>{{indexes[0].num_aps_online}} APs online</p>
          <h6><strong>After</strong></h6>
          <p>{{indexes[1].num_aps_online}} APs online</p>
        </mat-expansion-panel>
        <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title>
              @if (checkClientTableGood) {
                <mat-icon class="resultsIconSuccess">check_circle</mat-icon>
              }
              @if (!checkClientTableGood) {
                <mat-icon class="resultsIconFailure">remove_circle</mat-icon>
              }
              Clients on Ports 1-18, 22
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <!-- <p><strong>All Devices Removed</strong></p>
          <ul>
            <div *ngFor="let client of clients_in_1_not_2">
              <li>{{client.description}} | {{client.mac}} | {{client.manufacturer}} | Port {{client.switchport}} | {{client.recentDeviceName}}</li>
            </div>
          </ul> -->
          @if (devices_removed.length > 0) {
            <h6><strong>Devices Removed</strong></h6>
          }
          @if (devices_removed.length > 0) {
            <table class="clientsTable badTable">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>MAC</th>
                  <th>Manufacturer</th>
                  <th>Port</th>
                  <th>Switch</th>
                </tr>
              </thead>
              <tbody>
                @for (client of devices_removed; track client) {
                  <tr>
                    <td>{{client.description}}</td>
                    <td>{{client.mac}}</td>
                    <td>{{client.manufacturer}}</td>
                    <td>{{client.switchport}}</td>
                    <td>{{client.recentDeviceName}}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
          <!-- <ul>
          <div *ngFor="let client of devices_removed">
            <li>{{client.description}} | {{client.mac}} | {{client.manufacturer}} | Port {{client.switchport}} | {{client.recentDeviceName}}</li>
          </div>
        </ul> -->
        <!-- <p><strong>All Devices Added</strong></p>
        <ul>
          <div *ngFor="let client of clients_in_2_not_1">
            <li>{{client.description}} | {{client.mac}} | {{client.manufacturer}} | Port {{client.switchport}} | {{client.recentDeviceName}}</li>
          </div>
        </ul> -->
        @if (devices_added.length > 0) {
          <h6><strong>Devices Added</strong></h6>
        }
        @if (devices_added.length > 0) {
          <table class="clientsTable">
            <thead>
              <tr>
                <th>Description</th>
                <th>MAC</th>
                <th>Manufacturer</th>
                <th>Port</th>
                <th>Switch</th>
              </tr>
            </thead>
            <tbody>
              @for (client of devices_added; track client) {
                <tr>
                  <td>{{client.description}}</td>
                  <td>{{client.mac}}</td>
                  <td>{{client.manufacturer}}</td>
                  <td>{{client.switchport}}</td>
                  <td>{{client.recentDeviceName}}</td>
                </tr>
              }
            </tbody>
          </table>
        }
        <!-- <ul>
        <div *ngFor="let client of devices_added">
          <li>{{client.description}} | {{client.mac}} | {{client.manufacturer}} | Port {{client.switchport}} | {{client.recentDeviceName}}</li>
        </div>
      </ul> -->
      @if (devices_swapped_to_bad_port.length > 0) {
        <h6 ><strong>Devices Swapped to Bad Port</strong></h6>
      }
      @if (devices_swapped_to_bad_port.length > 0) {
        <table class="clientsTable badTable">
          <thead>
            <tr>
              <th>Description</th>
              <th>MAC</th>
              <th>Manufacturer</th>
              <th>Switch</th>
              <th>Current Port</th>
              <th>Previous Port</th>
            </tr>
          </thead>
          <tbody>
            @for (client of devices_swapped_to_bad_port; track client) {
              <tr>
                <td>{{client.description}}</td>
                <td>{{client.mac}}</td>
                <td>{{client.manufacturer}}</td>
                <td>{{client.recentDeviceName}}</td>
                <td>{{client.switchport}}</td>
                <td>{{client.previousSwitchport}}</td>
              </tr>
            }
          </tbody>
        </table>
      }
      <!-- <ul>
      <div *ngFor="let client of devices_swapped_to_bad_port">
        <li>{{client.description}} | {{client.mac}} | {{client.manufacturer}} | {{client.recentDeviceName}} from port {{client.previousSwitchport}} to port {{client.switchport}}</li>
      </div>
    </ul> -->
  </mat-expansion-panel>
  <mat-expansion-panel hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        @if (checkSwitchCountsGood) {
          <mat-icon class="resultsIconSuccess">check_circle</mat-icon>
        }
        @if (!checkSwitchCountsGood) {
          <mat-icon class="resultsIconFailure">remove_circle</mat-icon>
        }
        Switch Model Counts
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <h5>MS225s online before install: @if (!checkSwitchCountsGood) {
      <span class="redText">{{countMS225OnlineBeforeInstall}}</span>
      }@if (checkSwitchCountsGood) {
      <span class="greenText">{{countMS225OnlineBeforeInstall}}</span>
    }</h5>
    <h5>MS210s online after install: @if (!checkSwitchCountsGood) {
      <span class="redText">{{countMS210OnlineAfterInstall}}</span>
      }@if (checkSwitchCountsGood) {
      <span class="greenText">{{countMS210OnlineAfterInstall}}</span>
    }</h5>
    <h5>Statuses after install: </h5>
    <h6><strong>MS225</strong></h6>
    @if (switchesMS225.length > 0) {
      <table class="clientsTable">
        <thead>
          <tr>
            <th>Name</th>
            <th>MAC</th>
            <th>Serial</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          @for (switch of switchesMS225; track switch) {
            <tr>
              <td>{{switch.name}}</td>
              <td>{{switch.mac}}</td>
              <td>{{switch.serial}}</td>
              <td>{{switch.status}}</td>
            </tr>
          }
        </tbody>
      </table>
    }
    <!-- <ul>
    <div *ngFor="let switch of switchesMS225">
      <li>{{switch.name}} | {{switch.mac}} | {{switch.serial}}</li>
    </div>
  </ul> -->
  <h6><strong>MS210</strong></h6>
  @if (switchesMS210.length > 0) {
    <table class="clientsTable">
      <thead>
        <tr>
          <th>Name</th>
          <th>MAC</th>
          <th>Serial</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        @for (switch of switchesMS210; track switch) {
          <tr>
            <td>{{switch.name}}</td>
            <td>{{switch.mac}}</td>
            <td>{{switch.serial}}</td>
            <td>{{switch.status}}</td>
          </tr>
        }
      </tbody>
    </table>
  }
  <!-- <ul>
  <div *ngFor="let switch of switchesMS210">
    <li>{{switch.name}} | {{switch.mac}} | {{switch.serial}}</li>
  </div>
</ul> -->
<h6><strong>MS120</strong></h6>
@if (switchesMS120.length > 0) {
  <table class="clientsTable">
    <thead>
      <tr>
        <th>Name</th>
        <th>MAC</th>
        <th>Serial</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      @for (switch of switchesMS120; track switch) {
        <tr>
          <td>{{switch.name}}</td>
          <td>{{switch.mac}}</td>
          <td>{{switch.serial}}</td>
          <td>{{switch.status}}</td>
        </tr>
      }
    </tbody>
  </table>
}
<!-- <ul>
<div *ngFor="let switch of switchesMS120">
  <li>{{switch.name}} | {{switch.mac}} | {{switch.serial}}</li>
</div>
</ul> -->
</mat-expansion-panel>
<mat-expansion-panel hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>
      @if (checkPorts2324Good) {
        <mat-icon class="resultsIconSuccess">check_circle</mat-icon>
      }
      @if (!checkPorts2324Good) {
        <mat-icon class="resultsIconFailure">remove_circle</mat-icon>
      }
      Ports 23, 24 Active
    </mat-panel-title>
    <mat-panel-description>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <h6><strong>MS210s with Port 23 Offline</strong></h6>
  <p>{{switchesPort23Offline.join(", ")}}</p>
  <h6><strong>MS210s with Port 23 Not Found</strong></h6>
  <p>{{switchesPort23NotFound.join(", ")}}</p>
  <h6><strong>MS210s with Port 24 Offline</strong></h6>
  <p>{{switchesPort24Offline.join(", ")}}</p>
  <h6><strong>MS210s with Port 24 Not Found</strong></h6>
  <p>{{switchesPort24NotFound.join(", ")}}</p>
</mat-expansion-panel>
<mat-expansion-panel hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title>
      @if (checkWan1Good) {
        <mat-icon class="resultsIconSuccess">check_circle</mat-icon>
      }
      @if (!checkWan1Good) {
        <mat-icon class="resultsIconFailure">remove_circle</mat-icon>
      }
      On WAN1
    </mat-panel-title>
    <mat-panel-description>
    </mat-panel-description>
  </mat-expansion-panel-header>
</mat-expansion-panel>
<!-- <mat-expansion-panel hideToggle>
<mat-expansion-panel-header>
  <mat-panel-title>
    <mat-icon class="resultsIconSuccess" *ngIf="checkSTPBlockingGood">check_circle</mat-icon>
    <mat-icon class="resultsIconFailure" *ngIf="!checkSTPBlockingGood">remove_circle</mat-icon>
    STP Blocking on One Port (In Progress)
  </mat-panel-title>
  <mat-panel-description>
  </mat-panel-description>
</mat-expansion-panel-header>
<p><strong>Before</strong></p>
<p>{{indexes[0].num_aps_online}} APs online</p>
<p><strong>After</strong></p>
<p>{{indexes[1].num_aps_online}} APs online</p>
</mat-expansion-panel> -->
</mat-accordion>
</div>
}
</div>


